import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import PropertyType from "./PropertyType";
import FirstNameLastName from "./FirstNameLastName";
import ElectricityBill from "./ElectricityBill";
import Location from "./Location";
import EmailAndPhone from "./EmailAndPhone";
import logoImage from '../assets/images/safa_energy_logo_gray_img.png'
import './style.css';
import { useNavigate } from "react-router-dom";

const steps = [
  { id: 1, component: <PropertyType /> },
  { id: 2, component: <ElectricityBill /> },
  { id: 3, component: <Location/> },
  { id: 4, component: <FirstNameLastName /> },
  { id: 5, component: <EmailAndPhone /> },
];

export default function StepForm() {
 
  const [stepIndex, setStepIndex] = useState(0);
  const [direction, setDirection] = useState(1); // 1 for next, -1 for previous 

  const navigate = useNavigate();


  const nextStep = () => {
    if (stepIndex < steps.length - 1) {
      setDirection(1);
      setStepIndex(stepIndex + 1);
    }else {
      navigate("/success-screen"); 
    }
  };

  const prevStep = () => {
    if (stepIndex > 0) {
      setDirection(-1);
      setStepIndex(stepIndex - 1);
    }
  };

  return (
    <div >
       <div>
 <img className="lg:w-64 md:w-52 w-32 py-4  mx-auto" src={logoImage}/>

 <div className="relative w-full h-[2px] bg-gray-200 rounded-full">
 <div
    className="absolute outline-none shadow-[0px_0px_10px_rgba(234,179,8,0.8)] drop-shadow-sm top-0 left-0 h-[2px] bg-yellow-500 rounded-full transition-all duration-300"
    style={{ width: `${((stepIndex + 1) / steps.length) * 100}%` }}
  ></div>
     <div
    className="absolute top-[-5px] right-[-5px] w-[10px] h-[10px] bg-yellow-500 rounded-full"
    style={{ right: `calc(100% - ${((stepIndex + 1) / steps.length) * 100}%)` }}
  ></div>
</div>
 <p className="py-2 text-end mx-4 font-bold text-gray-900">{steps[stepIndex].id}/5</p>
</div>
  {/* Back Button in Top-Left Corner */}
  {stepIndex > 0 ? (
        <button
          onClick={prevStep}
          className="absolute md:top-8 top-2 left-2 px-4 py-2  rounded"
        >
         <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 -960 960 960" width="42px" fill="#000"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
        </button>
      ):
      (
        <button
          onClick={() => window.location.href = '../'}
          className="absolute md:top-8 top-2 left-2 px-4 py-2 rounded"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="42px" fill="#000">
            <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/>
          </svg>
        </button>
      )
      }
    <AnimatePresence mode="wait" custom={direction}>
        <motion.div
          key={steps[stepIndex].id}
          initial={{ x: direction * 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: direction * -100, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="mt-2"
        >
          {steps[stepIndex].component}
        </motion.div>
      </AnimatePresence>

      <div className="flex items-center justify-center md:mt-4 mt-2">
        <button
          onClick={nextStep}
          className="shadow-[rgb(111,127,232)] shadow-md flex items-center text-white md:py-4 py-3 md:px-8 px-6 font-bold bg-[#2e46b9] hover:bg-[#243794] text-base rounded-xl"
        >
          {stepIndex === steps.length - 1 ? "Submit" : "Next"}
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF" className="ml-2">
    <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/>
  </svg>
        </button>
      </div>
    </div>
  );
}
